import React from 'react';

/** @type {React.Context<DataLossGuardConnector>} */

export const DataLossGuardConnectorContext = React.createContext();
